module.exports = __webpack_public_path__ + "img/Unidad14-2.74f7f4e7.png";